/*
 *  Scroll Down
 *    Scripts for scroll down button
 *
 *  Version:
 *    1.0.0 - 2022/09/01
 */

const SELECTOR_SCROLL_DOWN = '[data-scroll-down]';

const scrollDown = document.querySelector(SELECTOR_SCROLL_DOWN);

// When the user clicks on the button, scroll down by screen height
const onClick = () => {
  const screenHeight = window.innerHeight;
  $("html, body").animate({ scrollTop: screenHeight }, "smooth");
}

if (scrollDown) scrollDown.addEventListener('click', onClick);